import DOMPurify from 'dompurify'
import { MARKING_STORED_TAGS } from '#shared/utils/markings/rules'

/**
 * Last line of defense before the `v-html` sink: fragments are sanitized at
 * capture and on server write, but records predating the server enforcement
 * bypass both — DOMPurify re-runs the shared allowlist right before render.
 */
export function sanitizeMarkingHtmlForRender(html: string | undefined): string {
  return DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: [...MARKING_STORED_TAGS],
    ALLOWED_ATTR: ['class', 'src', 'alt'],
    // src must stay http(s) or site-relative — DOMPurify's default URI regexp
    // would happily keep data: URIs on images.
    ALLOWED_URI_REGEXP: /^(?:https?:\/\/|\/(?!\/))/i,
  })
}
